import { Direccion } from "../interfaces/direccion.interface";
import { CABA, GOOGLE_MAPS_API_KEY, LIMITE_DISTANCIA, VALIDACION_CABA_REGEX } from "../utils/constants";
import { eliminarAcentos, localidadNormalizada } from "../utils/utils";

/**
 * Inserta el script necesario para llamar a la api de google con sus correspondientes librerias.
 */
const instanciarGoogleServices = () => {
    const src = "https://maps.googleapis.com/maps/api/js?libraries=places,geometry&key=" + GOOGLE_MAPS_API_KEY();
    const position = document.querySelector("head");
    const id = "asistencia-google-maps";

    if (!position) {
        return;
    }
    if (!document.querySelector("#" + id)) {
        const script = document.createElement("script");
        script.setAttribute("async", "");
        script.setAttribute("id", id);
        script.src = src;

        // Agrega un evento onload para verificar cuándo se ha cargado la API.
        script.onload = function () {
            if (typeof google.maps.geometry === 'object') {
                // La biblioteca de "geometry" se ha cargado correctamente.
                console.info("La biblioteca de geometry se ha cargado.");
            } else {
                console.error("La biblioteca de geometry no se ha cargado correctamente.");
            }
        }

        position.appendChild(script);
    }
}

/**
 * Recibe como parametro la geolocalización para realizar un pedido a la api de google retornando una dirección con localidad
 * y barrio en el caso de ser necesario
 * @param latitud
 * @param longitud
 */
const direccionGeocode = (latitud: number, longitud: number) => {
    return new Promise<any>((resolve) => {
        const latlng = new google.maps.LatLng(latitud, longitud);
        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ 'location': latlng }, function (results, status) {
            if (status === 'OK') {
                if (results.length > 0) {
                    let calle = '';
                    let altura = '';
                    let localidad = '';
                    let provincia = '';
                    let barrio = '';
                    //TODO: probar
                    for (let i = 0; i < results.length; i++) {
                        const addressComponents = results[i].address_components;
                        addressComponents.forEach((component) => {
                            const { types } = component;
                            if (types.includes('administrative_area_level_1') && !provincia) {
                                const province = component.short_name == "DF" ? CABA : component.long_name;
                                if (province.match(VALIDACION_CABA_REGEX)) {
                                    provincia = CABA;
                                } else {
                                    const match = province.match(/Provincia de (.+)/);
                                    provincia = match && match[1] ? match[1] : province;
                                }
                            } else if (types.includes('route') && !calle) {
                                calle = component.long_name;
                            } else if (types.includes('street_number') && !altura) {
                                altura = component.long_name;
                            } else if ((types.includes('locality') || types.includes('administrative_area_level_2')) && !localidad) {
                                localidad = component.short_name === 'CABA' ? CABA : component.long_name;
                                if (localidad.length < 5) {
                                    localidad = '';
                                    if (provincia == CABA)
                                        localidad = CABA
                                }
                            } else if ((types.includes('sublocality') || types.includes('neighborhood')) && !barrio) {
                                barrio = component.long_name;
                            }
                        })
                        if (calle && altura && localidad && provincia && barrio) break;
                    }
                    let localidadSinAcentos = eliminarAcentos(localidad);
                    let provinciaSinAcentos = eliminarAcentos(provincia);
                    localidadSinAcentos = localidadSinAcentos.toUpperCase();
                    let localidadFormateada = localidadNormalizada(localidadSinAcentos);
                    localidadFormateada = (provinciaSinAcentos === CABA) ? CABA : localidadFormateada;

                    let direccion = {
                        calle,
                        altura,
                        localidad: localidadFormateada,
                        provincia: provinciaSinAcentos.toUpperCase(),
                        barrio: barrio.toUpperCase(),
                        latitud,
                        longitud
                    }
                    resolve(direccion);
                } else {
                    console.error('No se encontraron resultados de geocodificación.');
                }
            } else {
                console.error('Error en la solicitud de geocodificación: ' + status);
            }
        });
    })
}

/**
 * Se encarga de establecer la geolocalizacion para comprobar
 * que se encuentre cerca de alguna direccion cargada.
 */
const checkearGeolocalizacion = (direcciones, direccionSeleccionada, geolocalizacion) => {
    return new Promise<any>((resolve, reject) => {
        if (geolocalizacion) {
            let latitude = geolocalizacion.coords.latitude;
            let longitude = geolocalizacion.coords.longitude;
            let precision = geolocalizacion.coords.accuracy;

            const positionUser = new google.maps.LatLng(latitude, longitude);

            let menorDistancia = 0;
            let menorDireccion: Direccion;
            let menorBandera = true;

            direcciones.forEach((direccion: Direccion) => {
                if (direccion.posicionExacta) {
                    let positionDireccion = new google.maps.LatLng(direccion.latitud, direccion.longitud);

                    let distancia = google.maps.geometry.spherical.computeDistanceBetween(
                        positionUser,
                        positionDireccion
                    );
                    if ((menorBandera || distancia < menorDistancia) && distancia < LIMITE_DISTANCIA) {
                        menorBandera = false;
                        menorDistancia = distancia;
                        menorDireccion = direccion;
                    }
                }
            });
            if (menorDireccion !== null && menorDireccion !== undefined && menorDireccion !== direccionSeleccionada) {
                if (menorDireccion.codigoPostal == direccionSeleccionada.codigoPostal &&
                    menorDireccion.altura == direccionSeleccionada.altura &&
                    menorDireccion.calle == direccionSeleccionada.calle
                ) {
                    resolve(null);
                } else {
                    resolve(menorDireccion);
                }
            } else {
                resolve(null);
            }
        } else {
            resolve(null);
        }
    });
}

export { instanciarGoogleServices, direccionGeocode, checkearGeolocalizacion }